module.exports = __webpack_public_path__ + "components/flag/static/square/je-eba3b32e22995fa17dbd0ac49c3ec372.svg";